export const dataUrlToBlob = async (dataUrl) => {
    const res = await fetch(dataUrl);
    return await res.blob();
};

export const isSignatureEmpty = (signatureRef) => {
    return signatureRef.current?.isEmpty() ?? true;
};

export const getSignatureData = (signatureRef) => {
    if (!signatureRef.current || signatureRef.current.isEmpty()) {
        return null;
    }

    return signatureRef.current
        .getTrimmedCanvas()
        .toDataURL("image/png");
};

export const clearSignature = (signatureRef) => {
    signatureRef.current?.clear();
};